import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop'
import { DOCUMENT, NgStyle } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  signal,
  ViewChild,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatDialog } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ScenarioService } from '@components/panel/tabs/scenario-tab/scenario.service'
import { SelectionToolComponent } from '@components/tools-bar/selection-tools/selection-tool.component'
import { CalculationModuleService } from '@core/services/calculation-module.service'
import { UploadedLayersService } from '@core/services/layers-uploaded.service'
import { MapService } from '@core/services/map.service'
import { SelectionScaleService } from '@core/services/selection-scale.service'
import { SessionManagerService } from '@core/services/session-manager.service'
import { MatomoTracker } from 'ngx-matomo-client'
import { DialogSnapshotComponent } from './dialog-snapshot/dialog-snapshot.component'
import { DialogSnapshotsListComponent } from './dialog-snapshots-list/dialog-snapshots-list.component'

@Component({
  selector: 'app-tools-bar',
  templateUrl: './tools-bar.component.html',
  styleUrl: './tools-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.Default, // allow snapshot to change scale level
  imports: [
    NgStyle,
    CdkDrag,
    CdkDragHandle,

    // Form
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,

    // Material
    MatSelectModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    SelectionToolComponent,
    MatTooltipModule,
  ],
})
export class ToolsBarComponent {
  mapBoundary: HTMLElement | null = null
  @ViewChild('toolsBar') toolsBar!: ElementRef<HTMLElement>
  left$ = signal<number>(0)

  readonly sessionManagerService = inject(SessionManagerService)
  private readonly _doc = inject(DOCUMENT)
  private readonly _tracker = inject(MatomoTracker)
  private readonly _uploadedLayersService = inject(UploadedLayersService)
  private readonly _mapService = inject(MapService)
  calculationModuleService = inject(CalculationModuleService)
  scenarioService = inject(ScenarioService)
  selectionScaleService = inject(SelectionScaleService)

  isLoggedIn$ = this.sessionManagerService.isLoggedIn$

  buttonToolSelected = 'click'
  isClearBtnDisabled$ = signal<boolean>(true)

  readonly dialog = inject(MatDialog)

  personalLayersState$ = this._uploadedLayersService.personalLayersState$
  sharedLayersState$ = this._uploadedLayersService.sharedLayersState$

  ngOnInit() {
    //  Limit of grab area
    const mapBoundary = this._doc.getElementById('map')
    if (mapBoundary) {
      this.mapBoundary = mapBoundary
    }
    this._mapService.initBackgroundMaps()
  }

  ngAfterViewInit() {
    // Place bar at center (but not moving at resize, because of draggable)
    const widthOfElement = this.toolsBar.nativeElement.offsetWidth
    this.left$.set(window.innerWidth / 2 - widthOfElement / 2)
  }

  changeSelectableAreas() {
    const element = document.getElementById('selectSelectableAreas') as HTMLInputElement
    const value = element.value

    // Matomo Event from the Selectable Areas control
    this._tracker.trackEvent('Selectable Areas', 'Change area', value)

    this.selectionScaleService.setSelectableArea(value)
  }

  changeBackgroundMap(e: MatButtonToggleChange) {
    this._mapService.setBackgroundMap(e.value)
    this._tracker.trackEvent('Background map', 'Change area', e.value)
  }

  addSnapshot() {
    this.dialog.open(DialogSnapshotComponent, {
      minWidth: '50vw',
      disableClose: true,
      data: '',
    })
  }

  openMySnapshots() {
    this.dialog.open(DialogSnapshotsListComponent, { minWidth: '60vw' })
  }
}
